'use strict';

let lazy = [];
let offset = 300;

function setLazy(){
    lazy = document.getElementsByClassName('lazy');
}

function cleanLazy(){
    lazy = Array.prototype.filter.call(lazy, function(l){ return l.getAttribute('data-src') || l.getAttribute('data-background');});
}

function isInViewport(el){
    var rect = el.getBoundingClientRect();

    return (
        rect.bottom >= 0 &&
        rect.right >= 0 &&
        rect.top <= (window.innerHeight+offset || document.documentElement.clientHeight+offset) &&
        rect.left <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

function lazyLoadImages(){

    for(var i=0; i<lazy.length; i++){
        if(isInViewport(lazy[i])){

            if (lazy[i].getAttribute('data-src')){

                // if (lazy[i].getAttribute('data-src').indexOf('w-centrum-uwagi.svg') === -1) {

                    var newImg = new Image();
                    newImg.el = lazy[i];
                    newImg.onload = function () {
                        $(this.el).attr('src', this.src);
                        $(this.el).removeAttr('data-src');
                        $(this.el).removeClass('lazy');
                    }
                    newImg.src = lazy[i].getAttribute('data-src');

                // } else {
                //     //load animated map js
                //     let element = $(lazy[i]);
                //     $(element).removeAttr('data-src');
                //     $.get( 'assets/js/w-centrum-uwagi.html', function( data ) {
                //         $(element).parent().html( data );
                //     });
                // }

            }

            if (lazy[i].getAttribute('data-background')){

                var newBg = new Image();
                newBg.el = lazy[i];
                newBg.onload = function() {
                    $(this.el).css('background-image', 'url(' + this.src + ')');
                    $(this.el).removeAttr('data-background');
                    $(this.el).removeClass('lazy');
                }
                newBg.src = lazy[i].getAttribute('data-background');

            }
        }
    }

    cleanLazy();
}

function registerListener(event, func) {
    if (window.addEventListener) {
        window.addEventListener(event, func);
    } else {
        window.attachEvent('on' + event, func);
    }
}

export default function lazyLoad() {
    setLazy();
    lazyLoadImages();
    registerListener('scroll', lazyLoadImages);
    registerListener('resize', lazyLoadImages);
}
